module.exports = __webpack_public_path__ + "static/loader-41e74cd555a6f8ae5d0f0426e87f9bf0.gif";